// AdminDataList.js
import { useState } from "react";
import { Table } from "react-bootstrap";
import styles from "../styles/adminDataList.module.css"; // Update CSS as needed
import AdminDataListItem from "./adminDataListItem";

const ITEMS_PER_PAGE = 20;

const AdminDataList = ({
  items,
  columns,
  actions,
  onItemSelect,
}: {
  items: any[];
  columns: any[];
  actions: any[];
  onItemSelect?: any;
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <div className={styles.wrapper}>
      <Table responsive className="table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.header}>{col.header}</th>
            ))}
            <th>Actions</th>
            <th className="text-white">Blank</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((item, index) => (
            <AdminDataListItem
              key={index}
              item={item}
              columns={columns}
              actions={actions}
              onItemSelect={onItemSelect}
            />
          ))}
        </tbody>
        <tfoot>
          <tr className="text-white"> temporary</tr>
          <tr className="text-white"> fix</tr>
        </tfoot>
      </Table>
      {/* Pagination component here */}
    </div>
  );
};

export default AdminDataList;
